class MasonryGrid extends HTMLElement {
    constructor() {
        super(),

        new Masonry( '.blog-masonry-grid', {
            itemSelector: '.blog-masonry-item',
            columnWidth: ".grid-sizer",
            gutter: ".gutter-sizer"
        });
    }
}
customElements.define("masonry-grid", MasonryGrid);
